module.exports = __webpack_public_path__ + "static/media/raycast_banner_150.fcafeebf.png";